export default __webpack_public_path__ + "static/media/20.998d20cc.svg";